import React from 'react'

const useAlphabeticNumericButtonTheme = () => {
  const defaultButtonTheme = [
    {
      class: 'border-[1px] border-v8-line pb-2',
      buttons:
        'q w e r t y u i o p del a s d f g h j k z x c v b n m l , . {arrowup} &#x222B &#8730 del &#946 {arrowup} space &#8730 Q W E R T Y U I O P del {shift} A S D F G H J K L &#946 Z X C V B N M',
    },
    {
      class: 'text-white',
      buttons: 'del',
    },
    {
      class: 'w-[220px]',
      buttons: 'space',
    },
    {
      class: 'ms-[100px]',
      buttons: '&#x222B',
    },
    {
      class: 'ms-[15px]',
      buttons: '&#946 q Q',
    },
    {
      class: 'me-[15px]',
      buttons: 'l',
    },
    {
      class: 'me-[40px]',
      buttons: '&#8730',
    },
    {
      class: 'bg-[#FF692E]',
      buttons: 'del',
    },
    {
      class: 'bg-[#8098F9]',
      buttons: '{capslock}',
    },
    {
      class: 'bg-[#444CE7]',
      buttons: '&#946 &#x222B &#8730',
    },
    {
      class: 'text-white',
      buttons: '&#946 &#x222B &#8730 {capslock}',
    },
    {
      class: `bg-[url('/images/arrow.png')] bg-no-repeat bg-center v-none`,
      buttons: '{capslock}',
    },
    {
      class: `bg-[url('/images/beta.png')] bg-no-repeat bg-center v-none`,
      buttons: '&#946',
    },
    {
      class: `bg-[url('/images/sqaure_root.png')] bg-no-repeat bg-center v-none`,
      buttons: '&#8730',
    },
  ]

  return { defaultButtonTheme }
}

export default useAlphabeticNumericButtonTheme
